import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { DensityProvider } from "./context/DensityContext";
import Layout from "./components/site/Layout";
import ThemeApplier from "./components/site/ThemeApplier";
import SeoHead from "./components/site/SeoHead";
import { ProtectedRoute, AdminRoute, ActiveMemberRoute } from "./components/site/ProtectedRoute";

import Home from "./pages/Home";
import About from "./pages/About";
import Community from "./pages/Community";
import MembershipPlans from "./pages/MembershipPlans";
import Terms from "./pages/Terms";
import VerifyEmail from "./pages/VerifyEmail";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Media from "./pages/Media";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Join from "./pages/Join";
import PaymentResult from "./pages/PaymentResult";
import Dashboard from "./pages/member/Dashboard";
import Account from "./pages/Account";
import AdminApp from "./pages/admin/AdminApp";

export default function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <DensityProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors />
          <ThemeApplier />
          <SeoHead />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/community" element={<Community />} />
              <Route path="/membership" element={<MembershipPlans />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:id" element={<EventDetail />} />
              <Route path="/media" element={<Media />} />
              <Route path="/media/:id" element={<BlogDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/join" element={<Join />} />
              <Route path="/payment/success" element={<PaymentResult />} />
              <Route path="/payment/cancel" element={<PaymentResult />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ActiveMemberRoute><Dashboard /></ActiveMemberRoute>} />
            <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
            <Route path="/admin/*" element={<AdminRoute><AdminApp /></AdminRoute>} />
          </Routes>
        </BrowserRouter>
        </DensityProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}
